<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{$t('_ACCOUNT_SETTING.TITLE')}}</span>
    </page-header>
    <left-menu />
    <div class="main-content right-page-content pb-0" id="account-setting">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="content-wrapper">
        <v-row>
          <v-col cols="3">
            <div class="card-item pb-0">
              <div class="card-item-header">
                <label slot="header" class="card-item-title">{{$t("_ACCOUNT_SETTING.AVATAR")}}</label>
              </div>
              <div class="d-flex">
                <div
                  class="square"
                  @mouseover="changeAvatarOverlay(true)"
                  @mouseleave="changeAvatarOverlay(false)"
                >
                  <img
                    v-if="!data.avatar"
                    src="@/assets/svg/account-circle.svg"
                    class="square-content p-3"
                  />
                  <v-img v-if="data.avatar" :src="data.avatar" class="square-content" />
                  <v-overlay :absolute="true" :value="showAvatarOverlay">
                    <div class="d-flex">
                      <label class="d-flex justify-center btn-icon label-upload" for="input-file">
                        <v-icon color="#173d8f">mdi-upload</v-icon>
                      </label>
                      <v-btn
                        v-if="data.avatar"
                        @click="deleteAvatar"
                        color="white"
                        class="btn-icon ml-3"
                      >
                        <v-icon color="#173d8f">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-overlay>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="9">
            <div class="card-item">
              <div class="card-item-header">
                <label slot="header" class="card-item-title">{{$t("_ACCOUNT_SETTING.USER_INFO")}}</label>
              </div>
              <div class="card-item-content">
                <v-row>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.USERNAME")}}</label>
                    <input-text disabled :model="data.userName" />
                  </v-col>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.FULLNAME") + $t("REQUIRED")}}</label>
                    <input-text
                      :model.sync="data.fullName"
                      :error.sync="error.fullName.error"
                      maxlength="255"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.GENDER") + $t("REQUIRED")}}</label>
                    <v-radio-group v-model="data.gender" row class="input-gender">
                      <v-radio
                        color="#173d8f"
                        :label="$t('_ACCOUNT_SETTING.GENDER_MALE')"
                        :value="1"
                      ></v-radio>
                      <v-radio
                        color="#173d8f"
                        :label="$t('_ACCOUNT_SETTING.GENDER_FEMALE')"
                        :value="0"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.EMAIL") + $t("REQUIRED")}}</label>
                    <input-text
                      type="email"
                      :model.sync="data.email"
                      :error.sync="error.email.error"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label
                      class="label-input"
                    >{{$t("_ACCOUNT_SETTING.PHONE_NUMBER") + $t("REQUIRED")}}</label>
                    <input-text
                      :regex="REGEX_PHONE"
                      :model.sync="data.phoneNumber"
                      :error.sync="error.phoneNumber.error"
                    />
                  </v-col>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.ADDRESS")}}</label>
                    <input-text
                      :model.sync="data.address"
                      :error.sync="error.address.error"
                      maxlength="255"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.POSITION")}}</label>
                    <input-text
                      :model.sync="data.position"
                      :error.sync="error.position.error"
                      maxlength="255"
                    />
                  </v-col>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.GROUP")}}</label>
                    <input-text disabled :model="data.userGroup" />
                  </v-col>
                </v-row>
                <v-row no-gutters class="mt-2">
                  <v-col cols="12" class="text-right">
                    <button @click="validateInfo" class="main-btn btn-pmirary">{{$t('SAVE')}}</button>
                  </v-col>
                </v-row>
              </div>
            </div>

            <div v-if="!showChangePassword" class="card-item mt-5">
              <div class="card-item-content">
                <v-row aline="center">
                  <v-col cols="8" class="p-0">
                    <label
                      slot="header"
                      class="card-item-title"
                    >{{$t("_ACCOUNT_SETTING.CHANGE_PASSWORD")}}</label>
                  </v-col>
                  <v-col cols="4" class="p-0 text-right">
                    <button @click="enableChangePassword" class="main-btn btn-text">
                      <v-icon color="#173d8f" class="mr-1">mdi-pencil</v-icon>
                      {{$t('EDIT')}}
                    </button>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div v-else class="card-item mt-5">
              <div class="card-item-header">
                <label
                  slot="header"
                  class="card-item-title"
                >{{$t("_ACCOUNT_SETTING.CHANGE_PASSWORD")}}</label>
              </div>
              <div class="card-item-content">
                <v-row>
                  <v-col cols="6">
                    <label
                      class="label-input"
                    >{{$t("_ACCOUNT_SETTING.CURRENT_PASS") + $t("REQUIRED")}}</label>
                    <input-text
                      type="password"
                      classList="current-password"
                      :model.sync="data.oldPassword"
                      :error.sync="errorPassword.oldPassword.error"
                    />
                  </v-col>
                  <v-col cols="6"></v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label class="label-input">{{$t("_ACCOUNT_SETTING.NEW_PASS") + $t("REQUIRED")}}</label>
                    <input-text
                      type="password"
                      :model.sync="data.newPassword"
                      :error.sync="errorPassword.newPassword.error"
                    />
                  </v-col>
                  <v-col cols="6">
                    <label
                      class="label-input"
                    >{{$t("_ACCOUNT_SETTING.NEW_PASS_REPEAT") + $t("REQUIRED")}}</label>
                    <input-text
                      type="password"
                      :model.sync="data.retypeNewPassword"
                      :isRealtimeValidate="true"
                      :error.sync="errorPassword.retypeNewPassword.error"
                      :errorMessage="errorPassword.retypeNewPassword.message"
                      :successMessage="errorPassword.retypeNewPassword.successMessage"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters class="mt-2">
                  <v-col cols="12" class="text-right">
                    <button class="main-btn btn-pmirary" @click="validatePassword">{{$t('SAVE')}}</button>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <upload-avatar @completed="completedUpload" />
    </div>
  </v-app>
</template>

<style lang="scss" scoped>
#account-setting {
  .square {
    position: relative;
    flex-basis: 100%;
    box-sizing: border-box;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    &::before {
      content: "";
      display: block;
      padding-top: 100%;
    }
    & .square-content {
      border-radius: inherit;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
  .btn-icon {
    min-width: 50px;
    min-height: 50px;
    padding: 0;
  }
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import Input from "@/components/Utils/Input.vue";
import UploadAvatarComponent from "@/components/Account/UploadAvatarComponent.vue";
import { getAsError, getAsPassError } from "@/_helpers/config.js";
import { REGEX_PHONE } from "@/_helpers/constant.js";
import eventBus from "@/_helpers/event-bus.js";
import store from "@/plugins/store";
import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { authenticationService } from "@/_services";
import { service } from "@/_services/Account/Setting/account-setting.service.js";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu,
    "input-text": Input,
    "upload-avatar": UploadAvatarComponent
  },
  data() {
    return {
      isLoading: false,
      data: {
        gender: 1
      },
      error: getAsError(), // Always get new error object when created component
      errorPassword: getAsPassError(), // Always get new errorPassword object when created component
      showAvatarOverlay: false,
      showUploadController: false,
      showChangePassword: false
    };
  },
  watch: {
    data: {
      handler(value) {
        let newPass = value.newPassword;
        let newRetypePass = value.retypeNewPassword;
        if (newPass && newRetypePass) {
          if (newPass == newRetypePass) {
            this.errorPassword.retypeNewPassword.error = false;
            this.errorPassword.retypeNewPassword.successMessage = this.$t(
              "_ACCOUNT_SETTING.MESSAGE_PASSWORD_MATCHED"
            );
            this.errorPassword.retypeNewPassword.message = "";
          } else {
            this.errorPassword.retypeNewPassword.error = true;
            this.errorPassword.retypeNewPassword.successMessage = "";
            this.errorPassword.retypeNewPassword.message = this.$t(
              "_ACCOUNT_SETTING.MESSAGE_PASSWORD_NOT_MATCHED"
            );
          }
        } else {
          this.errorPassword.retypeNewPassword.error = false;
          this.errorPassword.retypeNewPassword.successMessage = "";
          this.errorPassword.retypeNewPassword.message = "";
        }
      },
      deep: true
    }
  },
  computed: {
    REGEX_PHONE() {
      return REGEX_PHONE;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    // Run when start
    initialize() {
      // Call service
      this.getProfile();
    },
    // Get user profile
    getProfile() {
      this.isLoading = true;
      service
        .getProfile()
        .then(res => (this.data = res.data))
        .finally(() => (this.isLoading = false));
    },
    // Validate user info, if valid then call updateInfo()
    validateInfo() {
      let { isValid, error } = _validateFormI18n(this.data, this.error);
      this.error = error;
      if (!isValid) return false;
      this.updateInfo();
    },
    // Update user info
    updateInfo() {
      let temp = {
        fullName: this.data.fullName,
        gender: this.data.gender,
        phoneNumber: this.data.phoneNumber,
        position: this.data.position,
        email: this.data.email,
        address: this.data.address
      };
      this.isLoading = true;
      service
        .updateInfo(temp)
        .then(res => {
          if (res) {
            _alert(res, this.$t(res.data), false);
            if (res.responseCode === 0) {
              eventBus.$emit("EVENT_RELOAD_USER");
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Show change password inputs
    async enableChangePassword() {
      this.showChangePassword = true;
      await setTimeout(function() {
        document.documentElement.scrollTop = window.innerHeight;
      }, 200);
      if (document.querySelector("input.current-password"))
        document.querySelector("input.current-password").focus();
    },
    // Validate password, if valid then call updatePassword()
    validatePassword() {
      this.errorPassword.retypeNewPassword.successMessage = "";
      let { isValid, error } = _validateFormI18n(this.data, this.errorPassword);
      this.errorPassword = error;
      if (!isValid) return false;
      if (this.data.newPassword !== this.data.retypeNewPassword) {
        const errorMessage = this.$t(
          "_ACCOUNT_SETTING.ERROR_PASSWORD_NOT_MATCH"
        );
        this.errorPassword.retypeNewPassword.error = true;
        this.errorPassword.retypeNewPassword.message = errorMessage;
        _alert(null, errorMessage, false);
        return false;
      }
      this.updatePassword();
    },
    // Update password
    updatePassword() {
      let temp = {
        oldPassword: this.data.oldPassword,
        newPassword: this.data.newPassword
      };
      this.isLoading = true;
      service
        .updatePassword(temp)
        .then(res => {
          if (res) {
            if (res.responseCode === 0) {
              // Logout and redirect to login page
              _alert(res, this.$t(res.data), false);
              authenticationService.logout(false);
              this.$router.push({ name: "login" });
            }
            if (res.data === "PASSWORD_OLD_INCORRECT") {
              // Override message keyword
              this.errorPassword.oldPassword.error = true;
              _alert(
                res,
                this.$t("_ACCOUNT_SETTING.ERROR_PASSWORD_INVALID"),
                false
              );
            } else {
              _alert(res, this.$t(res.data), false);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Open upload avatar dialog
    showUploadDialog() {
      this.showUploadController = true;
    },
    // Complete upload avbtar
    completedUpload() {
      this.showUploadController = false;
      eventBus.$emit("EVENT_RELOAD_USER");
      this.initialize();
    },
    // Delete user avatar
    deleteAvatar() {
      this.isLoading = true;
      service
        .deleteAvatar()
        .then(res => {
          if (res) {
            if (res.responseCode === 0) {
              // Reload user info
              this.getProfile();
              eventBus.$emit("EVENT_RELOAD_USER");
            }
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    changeAvatarOverlay(visible) {
      this.showAvatarOverlay = visible;
    }
  }
};
</script>
<style lang="scss" scoped>
.label-upload {
  background: #fff;
  width: 50px;
}
</style>